import { render, staticRenderFns } from "./studentFormComponent.vue?vue&type=template&id=92e4593a"
import script from "./studentFormComponent.vue?vue&type=script&lang=js"
export * from "./studentFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports